import React from 'react';
import DOMPurify from 'dompurify';
import type { HtmlBlock } from '@/types/contentBlocks';

interface HtmlBlockProps {
  block: HtmlBlock;
  isDarkMode: boolean;
}

export const HtmlBlockRenderer: React.FC<HtmlBlockProps> = ({ block, isDarkMode }) => {
  const sanitizedHtml = React.useMemo(() => {
    if (block.sanitized) {
      return block.content;
    }
    return DOMPurify.sanitize(block.content, {
      ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'u', 'span', 'div', 'p', 'br', 'a', 'img'],
      ALLOWED_ATTR: ['href', 'src', 'alt', 'title', 'class', 'style'],
    });
  }, [block.content, block.sanitized]);

  return (
    <div
      className={`my-2 ${isDarkMode ? 'text-gray-200' : 'text-gray-900'}`}
      dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
    />
  );
};
